<template>
<div class="desc-item" v-if="options.type === '01'">
  <div class="tit"><span class="label-tit">{{ title }}</span></div>
  <div class="desc">
    <div class="td-s-thumb search-area" style="width: 280px">
      <input class="input input-bg" type="text" v-model="data.deptCd" style="width:80px;" disabled="disabled">
      <div class="ip-box ip-box-w02">
        <input class="input" type="text" v-model="data.deptNm" :disabled="lock()" @input="initDept" @keypress.enter.prevent="query(data.deptNm)" />
        <button class="icon is-right modal-button" @click="openModal(data.deptNm)" v-if="!lock()">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="form-group" v-else-if="options.type === '02'">
  <label class="control-label">{{ title }}</label>
  <div class="form-input">
    <div class="search-box">
      <div class="input-group">
        <input type="text" class="input" disabled="disabled" v-model="data.deptCd" style="width: 80px;" />
        <input type="text" class="input search-input" v-model="data.deptNm" style="max-width: calc(100% - 88px);" :disabled="lock()" @keypress.enter.prevent="query(data.deptNm)" />
        <button type="button" class="btn-icon" @click="openModal(data.deptNm)" v-if="!lock()">
          <span class="btn-icon"><i class="fas fa-search"></i></span>
        </button>
      </div>
    </div>
  </div>
</div>
<div v-else></div>
</template>

<script>
import Dept from './Dept.vue'

const def_props = {
  type: '01',
  authorize: true,
  deptCd: 'deptCd',
  deptNm: 'deptNm'
}

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: '부서'
    },
    options: {
      type: Object,
      required: false,
      default () {
        return {
          type: '01',
          authorize: true,
          deptCd: 'deptCd',
          deptNm: 'deptNm'
        }
      }
    }
  },
  data() {
    return {
      data: {
        authority: undefined,
        deptCd: undefined,
        deptNm: undefined
      }
    }
  },
  methods: {
    lock() {
      if (this.options.authorize) {
        if (this.authority !== '10')
          return true
      }
      return false
    },
    submit(data) {
      data = data || {}
      // Apply data
      this.data.deptCd = data.deptCd
      this.data.deptNm = data.deptNm
      // Apply to parents
      this.value[this.options.deptCd] = this.data.deptCd
      this.value[this.options.deptNm] = this.data.deptNm
      this.$emit('input', this.value)
      this.$emit('submit')
    },
    query(searchStr) {
      if (searchStr) {
        this.$store.commit('loading')
        this.$http.get(`/api/dept/${searchStr}`)
          .then(response => {
            if (Array.isArray(response.data)) {
              if (response.data.length === 1) {
                this.submit(response.data[0])
              } else {
                this.openModal(searchStr)
              }
            } else {
              this.submit()
            }
            return response
          })
          .catch(() => {
            this.submit()
          })
          .finally(response => {
            this.$store.commit('finish')
          })
      } else {
        this.submit()
      }
    },
    openModal(searchStr) {
      let vm = this
      this.$modal.open({
        component: Dept,
        props: {
          title: this.title,
          searchStr: searchStr
        },
        parent: this,
        events: {
          close(data) {
            vm.submit.apply(vm, [data])
          }
        }
      })
    },
    initializeValues() {
      if (this.authority !== '10') {
        try {
          let loginInfo = this.$store.state.loginInfo
          this.data.deptCd = loginInfo.loginDeptCd
          this.data.deptNm = loginInfo.loginDeptNm
          this.value[this.options.deptCd] = this.data.deptCd
          this.value[this.options.deptNm] = this.data.deptNm
          this.$emit('input', this.value)
        } catch (e) {
          // ...
        }
      }
    },
    initDept(force) {
      if (force === true) {
        this.data.deptCd = '';
        this.submit();
      }
      if (this.data.deptNm === '') {
        this.data.deptCd = '';
        this.submit();
      }
    },
  },
  created() {
    try {
      let authority = this.$store.state.loginInfo.authorities.map(x => x.roleSelectCd)[0]
      if (!authority) {
        authority = undefined
      }
      this.authority = authority
      this.initializeValues()
    } catch (e) {}
  },
  watch: {
    'value': {
      immediate: true,
      deep: true,
      handler(value) {
        this.data = {
          deptCd: value[this.options.deptCd],
          deptNm: value[this.options.deptNm]
        }
      }
    },
    'options': {
      immediate: true,
      deep: true,
      handler(value) {
        for (var member in def_props) {
          if (value[member] === undefined) {
            value[member] = def_props[member]
          }
        }
        //this.initializeValues()
      }
    }
  }
}
</script>

<style scoped>
  .td-s-thumb.search-area .ip-box.ip-box-w02 {
    width: 60%;
    margin-left: 6px;
  }

  .td-s-thumb.search-area .ip-box {
    vertical-align: top;
  }

  @media (max-width:1580px) {
    .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
      width: 40%;
    }
  }
</style>